import { render } from "./IconTrekWeightBike.vue?vue&type=template&id=44675ae4"
import script from "./IconTrekWeightBike.vue?vue&type=script&lang=js"
export * from "./IconTrekWeightBike.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__